import { render, staticRenderFns } from "./dashboardGroupContextMenu.vue?vue&type=template&id=7d22a4e6"
import script from "./dashboardGroupContextMenu.vue?vue&type=script&lang=js"
export * from "./dashboardGroupContextMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports